import { format, addDays, differenceInMinutes, differenceInDays, parse } from 'date-fns'
import { IStepperPropstypes } from 'Models/Common'
import { IPincode, IPincodeOption, IHypothecation } from 'Models/ResponseModels'
import { IHealthPincode, IHealthPincodeOption } from 'Models/ResponseModels/Health'

import { KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { objectKeys } from 'ts-extras'
import { ILifePincode, IPincodeRes } from './API/BOB/bob_master.api'
import { ToastService } from './toast.service'
import { useAppSelector } from 'app/hooks'

const IndianRupeeFormatFromString = (num: string) => {
  if (num == '' || num === null) {
    return ''
  }
  return Intl.NumberFormat('en-IN').format(parseInt(num))
}

const IndianRupeeFormatFromStringOrNumber = (num: string | number | null | undefined): string => {
  if (num == '' || num === null || num === undefined) {
    return ''
  }
  if (num == '--') {
    return '0'
  }
  num = num?.toString()
  return Intl.NumberFormat('en-IN').format(parseFloat(num))
}

function capitalizeFirstLetter(str: string) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const onlyAllowTypingNumbers = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    !(
      e.key === 'Backspace' ||
      e.key === 'Tab' ||
      e.key === 'ArrowDown' ||
      e.key === 'ArrowLeft' ||
      e.key === 'ArrowRight'
    )
  ) {
    if (e.key.charCodeAt(0) < 48 || e.key.charCodeAt(0) > 57) {
      e.preventDefault()
    }
  }
}

const getFallbackImageHtml = (title: string) => {
  return `<div style="background-color: gainsboro;font-size: 0.7rem; border: solid 1px; padding: 0.6rem; display: flex; justify-content: center; align-items: center; width: fit-content;"><span>${title}</span></div>`
}

const onlyAllowTypingNumbers2 = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key.charCodeAt(0) < 48 || e.key.charCodeAt(0) > 57) {
    e.preventDefault()
  }
}
const onlyAllowTypingAlphabetNumeric = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123) ||
    (e.key.charCodeAt(0) > 47 && e.key.charCodeAt(0) < 58)
  ) {
    console.log('')
  } else {
    e.preventDefault()
  }
}

// const getManufacturingYearArr = (
//   startYear: number,
//   currentYear: number = new Date().getFullYear(),
// ): number[] => {
//   const arr = []
//   for (let year = startYear; year <= currentYear; year++) {
//     arr.push(year)
//   }
//   return arr
// }

const getManufacturingYearArr = (
  startYear: number,
  currentYear: number = new Date().getFullYear(),
): number[] => {
  const isNewVehicle = useAppSelector((state) => state.homePage.isNewVehicle)
  const arr = []
  for (let year = startYear; year <= (isNewVehicle ? currentYear : currentYear - 1); year++) {
    arr.push(year)
  }
  return arr
}

const policyNumberCheck = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    (e.key.charCodeAt(0) > 47 && e.key.charCodeAt(0) < 58) ||
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123) ||
    e.key.charCodeAt(0) === 35 ||
    e.key.charCodeAt(0) === 45 ||
    e.key.charCodeAt(0) === 46 ||
    e.key.charCodeAt(0) === 47
  ) {
    console.log('')
  } else {
    e.preventDefault()
  }
}

const getExistingNoClaimBonusArr = (): number[] => {
  return [0, 20, 25, 35, 45, 50]
}

const bankHypothecationLabelFormatter = (banksArray: IHypothecation[]) => {
  return banksArray.map((bank) => {
    return {
      ...bank,
      value: bank.id ?? '',
      label: bank.bank_name ?? '',
    }
  })
}
/* eslint-disable */
const customerConsentFormQuestionsMap = {
  q1: 'I confirm that I have received the Quote and have accepted the quote. I understand that the above proposal has been generated basis my acceptance of the quote',
  q21: 'I hereby authorize Bank of Baroda to debit my bank account for the premium amount as per this application. I understand that the debit will be processed basis my consent provided here.',
  q22: 'I understand that a payment link will be shared with me, and I will complete the transaction through the payment gateway using my preferred mode of payment.',
  q3: 'I hereby confirm that I have an active relationship with Bank Of Baroda. I confirm that the details furnished above are true to the best of my knowledge. I also understand that any misrepresentation of data or facts in the above request form could lead to termination of the policy or rejection of claim.',
  q4: 'I hereby confirm that you have a valid PUC since it is mandatory for issuance of vehicle insurance.',
  q5: 'I confirm that i have provided consent to verify my identity through central KYC registered at UIDAI or through any other modes for the purpose of understanding KYC.',
  q6: 'I hereby consent for my bank account to be debited for the motor insurance premium, whether the vehicle is registered in my name or not. I confirm that I am the proposer of this application and I am either the owner of the vehicle or I am acquainted with the vehicle owner',

  // q4: 'I/we understand and agree that by selecting the payment method as "My Equitas Account", I provide my consent to debit my account for the purpose of premium amount as per the application. I also understand that by selecting "Other modes of Payment", I\'d be taken to a Payment Gateway to make payment via any other preferred modes',
  // q5: 'I/We hereby confirm that I/we have an active relationship with Equitas Small Finance Bank Limited with a valid customer ID. I/we confirm that the details furnished above are true to the best of my knowledge. I/we also understand that any misrepresentation of data or facts in the above request form could lead to termination of the policy or rejection of claim.',
}

const checkForBHNumbers = (input: string) => {
  let result = ''

  if (input.length) {
    if (input.length >= 2) {
      const temp = input.slice(0, 2)
      if (!temp.match('[1-9]$')) {
        return result
      }
      result = result + temp
      // result += temp + '-BH-'
      console.log(`input ${input}  ${input.length} | result ${result} ${result.length}`)
      if (input.length > 2) {
        result = result + '-'
      }

      const tempBH = input.slice(2, 4)
      if (tempBH.match('[BH]$') && result.length < 5) {
        result = result + tempBH
      }
      if (input.length > 5) {
        result = result + '-'
      }

      const temp2 = input.slice(4, 8)
      if (temp2.match('[0-9]$') && result.length < 13) {
        result = result + temp2
      }
      if (input.length === 9 || input.length === 10) {
        result = result + '-'
      }
      const temp3 = input.slice(8, 15)

      if (temp3.match('[A-Z]$') && temp3.length < 3) {
        result = result + temp3
      }
    } else {
      if (input.match('[1-9]$')) {
        result += input
      }
    }
  }
  return result
}

const validateVehicleNumber = (input: string, e?: any) => {
  input = String(input).replace(/-/g, '').toUpperCase()
  let result = ''
  if (input[0] && input[0].match('[0-9]$')) {
    return checkForBHNumbers(input)
  }
  if (input.length >= 2) {
    const temp = input.slice(0, 2)
    if (!temp.match('[A-Z]$')) {
      return result
    }
    result += temp + '-'
    input = input.slice(2)
    if (input.length) {
      if (!input[0].match('[0-9]$')) {
        return result
      }
      result += input[0]
      input = input.slice(1)

      if (input.length) {
        if (input[0].match('[0-9]$')) {
          result += input[0]
          input = input.slice(1)
        } else if (input[0].match('[A-Z]$') && result.length === 4) {
          result = [result.slice(0, 3), '0', result.slice(3)].join('')
          // input = input.slice(1,)
        }
      }
      result += '-'
      let i = 0
      while (input && i < 3) {
        if (!input[0].match('[A-Z]$')) {
          break
        }
        result += input[0]
        input = input.slice(1)
        i += 1
      }
      if (i) {
        result += '-'
      }
      if (input) {
        const val = input.match(/^([0-9]+)/)
        if (val) {
          result += val[0]?.slice(0, 4)
        }
      }
    }
  } else {
    if (input.match('[A-Z]$')) {
      result += input
    }
  }
  result = result.match('(.+)-$') ? result.slice(0, result.length - 1) : result
  return result
}

const checkVehicleNumber = (number: string) => {
  if (number) {
    const str = number.split('-')
    if (str.length) {
      if (str[str.length - 1].length < 4) {
        return false
      }
    }
    return number.length >= 10
  }
}
const onlyAllowTypingAlphabet = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123) ||
    e.key == ' '
  ) {
    console.log('')
  } else {
    e.preventDefault()
  }
}

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
  ToastService.showSuccessTaost({ title: 'Copied to clipboard!' })
}

const getAgeFromDob = (dob: Date) => {
  const dobInNumber = +dob
  const todaysDate = +new Date()
  const ageInSeconds = todaysDate - dobInNumber
  return ageInSeconds / (24 * 3600 * 365.25 * 1000)
}

const getAge = (dob: string) => {
  const today = new Date()
  const birthDate = new Date(dob)
  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

const getDOBfromAge = (age: string) => {
  const dob = new Date().getFullYear() - parseInt(age)
  return dob.toString() + '-01-01'
}
const getMemberTypeFromAge = (age: string) => {
  let type = ''
  if (parseInt(age) >= 25) {
    type = 'adult'
  } else {
    type = 'child'
  }
  return type
}

const getDateFromDDMMYYYY = (dateInDDMMYYYY: string) => {
  const dateArr = dateInDDMMYYYY.split('/')
  const dateToBePassedInConstructor = `${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`
  return new Date(dateToBePassedInConstructor)
}

const getRegistrationDateFromManufacturingYear = (year: number | string) => {
  year = year.toString()
  if (year.length !== 4) {
    throw Error('Invalid Year')
  }
  const currentDate = new Date()
  const firstDateOfTwoYearsForwardYear = new Date(`${parseInt(year) + 2}/1/1`)
  console.log(differenceInMinutes(currentDate, firstDateOfTwoYearsForwardYear))
}

const pincodeLabelFormatter = (pincodesArray: IPincode[]) => {
  return pincodesArray.map((pincode) => {
    return {
      ...pincode,
      value: pincode.area,
      label: `${pincode.area_name}(${pincode.pincode})`,
    }
  })
}

const pincodeLabelFormatterLife = (pincodesArray: ILifePincode[]) => {
  return pincodesArray.map((pincode) => {
    return {
      ...pincode,
      value: pincode.pincode?.toString() ?? '',
      label: `${pincode.pincode}(${pincode.city_name})`,
    }
  })
}

const pincodeLabelFormatterHealth = (pincodesArray: IHealthPincode[]) => {
  return pincodesArray.map((pincode) => {
    return {
      ...pincode,
      value: pincode.area_code ? pincode.area_code.toString() : pincode.pincode,
      label: `${pincode.area_name != null ? pincode.area_name : pincode.city_name}(${
        pincode.pincode
      })`,
    }
  })
}
const getArrayFromObj = (obj: any) => {
  if (!obj) return []
  return Object.keys(obj).map((key) => {
    return {
      ...obj[key],
      key: key,
    }
  })
}

const getExistingPolicyExpMinDate = (registrationDate: string, isSaod: boolean) => {
  const registrationDateInDateFormat = getDateFromDDMMYYYY(registrationDate)
  if (registrationDateInDateFormat) {
    if (isSaod === true) {
      if (registrationDateInDateFormat && registrationDateInDateFormat.getFullYear() > 2018) {
        return new Date(`${registrationDateInDateFormat.getFullYear()}/01/01`)
      }
      return registrationDateInDateFormat ?? new Date()
    } else {
      return new Date(`${new Date().getFullYear() - 2}/01/01`)
    }
  }
}

const getTpPolicyEndMinDate = (policyExpDate: string) => {
  console.log('policyExpDate - ', policyExpDate)
  if (policyExpDate) {
    const policyExpDateInDateFormat = getDateFromDDMMYYYY(policyExpDate)
    return addDays(policyExpDateInDateFormat, 365)
  }
}

const calculateBMI = (height: number, weight: number) => {
  height = height / 100
  const bmi = weight / (height * height)
  return bmi.toFixed(2)
}

const getDropdownArrayFromRecord = (data: Record<string, string | number>) => {
  return Object.entries(data).map((item) => {
    return {
      label: item[0],
      value: item[1],
    }
  })
}
const showNestedError = (error: any) => {
  const errorList: { title: string; message: string }[] = []
  if (error && error.data && error.data.data) {
    const values: any[] = Object.values(error.data.data)
    if (values && values.length) {
      values.forEach((obj: any[]) => {
        obj.forEach((e) => {
          Object.keys(e).forEach((key) => {
            errorList.push({
              title: key.replaceAll('_', ' '),
              message: e[key],
            })
          })
        })
      })
    }
    if (
      errorList.length === 0 &&
      error &&
      error.data &&
      error.data.message &&
      typeof error.data.message === 'string'
    ) {
      errorList.push({
        title: '',
        message: error.data.message,
      })
    }
    errorList.forEach(({ message, title }) => {
      ToastService.showErrorToast({ title, message })
    })
  }
  return errorList.length ? true : false
}
const maxAgeCalculator = (arrayOfAges: number[]) => {
  // arrayOfAges = ['56', '60','34','12']
  let maxAge = arrayOfAges[0]
  for (let i = 0; i < arrayOfAges.length; i++) {
    if (arrayOfAges[i] > maxAge) {
      maxAge = arrayOfAges[i]
    }
  }
  return maxAge
}
const getAgeObjFromDob = (userinput: Date) => {
  const dob = new Date(userinput)
  // console.log(dob, 'dob from func')
  let monthAge
  let dateAge

  const dobYear = dob.getFullYear()
  const dobMonth = dob.getMonth()
  const dobDate = dob.getDate()

  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth()
  const currentDate = now.getDate()

  let yearAge = currentYear - dobYear

  if (currentMonth >= dobMonth) monthAge = currentMonth - dobMonth
  else {
    yearAge--
    monthAge = 12 + currentMonth - dobMonth
  }

  if (currentDate >= dobDate) dateAge = currentDate - dobDate
  else {
    monthAge--
    dateAge = 31 + currentDate - dobDate

    if (monthAge < 0) {
      monthAge = 11
      yearAge--
    }
  }
  const age = {
    years: yearAge,
    months: monthAge,
    days: dateAge,
  }

  if (age.years) return age.years + ' Years'
  if (age.months) return age.months + ' Months'
  return age.days + ' Days'
}
const getAccountTypeBasedOnIndex = (idx: string) => {
  switch (idx) {
    case '1':
      return 'Savings Account'
    case '2':
      return 'Current Account'
    case '3':
      return 'Term Deposit Account'
    case '4':
      return 'Recurring Deposit Account'
    default:
      return ''
  }
}

const getInvestmentType = (planType: 'endowment' | 'term' | 'ulip') => {
  if (['endowment', 'ulip'].includes(planType)) {
    return 'investment_amount'
  }
  return 'sum_assured'
}

const spConsentFormQuestionsMap = {
  q1: 'I confirm that I have discussed about the product with the customer and the customer has shown willingness to purchase the product.',
  q2: 'I confirm that the customer is making a decision to purchase the policy based on his/her own decision and it has not been linked for the purchase of any bank related products.',
  q3: 'I confirm that the information provided during the process of submitting the application form are true to the best of my knowledge.',
}
const onlyAllowAlphaNumeric = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    (e.key.charCodeAt(0) > 47 && e.key.charCodeAt(0) < 58) ||
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123)
  ) {
    console.log('')
  } else {
    e.preventDefault()
  }
}

const sortObjectBasedOnKeys = (object: Record<string, string>) => {
  const keys = objectKeys(object)

  keys.sort()

  const sortedObj: Record<string, string> = {}
  keys.forEach((key) => {
    sortedObj[key] = object[key]
  })

  return sortedObj
}

function formatSeconds(seconds: number) {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSeconds).padStart(2, '0')

  return `${formattedMinutes}:${formattedSeconds}`
}

const makeQuery = (query: any) => {
  return makeQueryChild(JSON.parse(JSON.stringify(query)))
}

const makeQueryChild = (query: any) => {
  const obj = query

  //  console.log('initial load' ,obj )

  // Array Found
  if (Array.isArray(obj)) {
    obj.forEach((value, index) => {
      // console.log(value,'array found')
      //  Object Inside Array
      if (typeof value == 'object') {
        makeQueryChild(value)
      }
    })
  }
  // Object Found
  else if (typeof obj == 'object') {
    Object.entries(obj).forEach(([key, value]) => {
      // This is for all objects and all arrays recursively calling for each data types

      if (obj[key] !== null && typeof obj[key] === 'object') {
        // console.log(obj[key],'obj[key] inside object')
        makeQueryChild(obj[key])
      } else if (obj[key] !== null && obj[key] !== '' && obj[key] !== undefined) {
        obj[key] = value
      } else {
        // console.log('i am deleting this key', key)
        delete obj[key]
      }
    })
  }
  return obj
}

const checkForNewBHNumbers = (input: string) => {
  let result = ''
  if (input.length) {
    if (input.length >= 2) {
      const temp = input.slice(0, 2)
      if (!temp.match('[1-9]$')) {
        return result
      }
      if (input.length === 2) {
        result += temp + '-BH'
      }
    } else {
      if (input.match('[1-9]$')) {
        result += input
      }
    }
  }
  return result
}

const validateVehicleRtoNumber = (input: string): string => {
  input = String(input).replace(/-/g, '').toUpperCase()

  if (input[0] && input[0].match('[0-9]$')) {
    return checkForNewBHNumbers(input)
  }
  let result = ''
  if (input.length >= 2) {
    const temp = input.slice(0, 2)
    if (!temp.match('[A-Z]$')) {
      return result
    }
    result += temp + '-'
    input = input.slice(2)
    if (input.length) {
      if (!input[0].match('[0-9]$')) {
        return result
      }
      result += input[0]
      input = input.slice(1)

      if (input.length) {
        if (input[0].match('[0-9]$')) {
          result += input[0]
          input = input.slice(1)
        }
        result += '-'
      }
    } else {
      if (input.match('[A-Z]$')) {
        result += input
      }
    }
  } else {
    if (input.match('[A-Z]$')) {
      result += input
    }
  }
  result = result.match('(.+)-$') ? result.slice(0, result.length - 1) : result
  return result
}

const detectDeviceType = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'Mobile'
    : 'Desktop'

// const maskEmail = (emailStr: string) => {
//   const emailArray = emailStr.split('')
//   const finalArr: string[] = []
//   const len = emailArray.indexOf('@')
//   emailArray.forEach((item, pos) => {
//     pos >= 1 && pos <= len - 2 ? finalArr.push('*') : finalArr.push(emailArray[pos])
//   })
//   return finalArr.join('')
// }

// function maskEmail(email: string) {
//   const atIndex = email.lastIndexOf('@')
//   if (atIndex === -1) {
//     return email
//   }

//   const maskedPart =
//     email.substring(0, Math.max(atIndex - 4, 1)) +
//     'x'.repeat(Math.min(4, atIndex)) +
//     email.substring(atIndex)

//   return maskedPart
// }

function maskEmail(email: string) {
  const parts = email.split('@')
  if (parts.length === 2) {
    const username = parts[0]
    const domain = parts[1]

    if (username.length > 4) {
      const maskedUsername = username.slice(0, -4) + '****'
      return maskedUsername + '@' + domain
    } else {
      const firstChar = username.charAt(0)
      const maskedUsername = firstChar + '*'.repeat(username.length - 1)
      return maskedUsername + '@' + domain
    }
  } else {
    // Handle invalid email format
    return email
  }
}

// function maskPhoneNumber(phoneNumber: string) {
//   // phoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-digit characters
//   const firstTwoDigits = phoneNumber.substring(0, 2)
//   const lastTwoDigits = phoneNumber.substring(phoneNumber.length - 2)

//   const maskedNumber = firstTwoDigits + 'x'.repeat(phoneNumber.length - 4) + lastTwoDigits
//   return maskedNumber
// }

// function maskPhoneNumber(phoneNumber: string) {
//   const digitsToMask = 4

//   if (phoneNumber.length <= digitsToMask) {
//     return '*'.repeat(phoneNumber.length)
//   } else {
//     const visibleDigits = phoneNumber.length - digitsToMask
//     const maskedPart = '*'.repeat(visibleDigits)
//     const lastFourDigits = phoneNumber.slice(-digitsToMask)
//     return maskedPart + lastFourDigits
//   }
// }

function maskPhoneNumber(number: string) {
  if (typeof number !== 'string' && typeof number !== 'number') {
    return 'Invalid input'
  }

  const numStr = String(number)
  const length = numStr.length

  if (length <= 4) {
    return numStr
  } else {
    const visibleDigits = numStr.slice(0, length - 4)
    const maskedDigits = '*'.repeat(4)
    return visibleDigits + maskedDigits
  }
}
const safeSplitFunction = (string: string, splitCharacter: string) => {
  try {
    if (typeof string == 'string') {
      return string.split(splitCharacter)
    } else {
      return []
    }
  } catch {
    return []
  }
}

function truncateStringToLimitedWords(inputString: string, maxLength: number) {
  // Check if the string is already shorter than the specified length
  if (inputString.length <= maxLength) {
    return inputString
  }

  // Find the last space within the specified length
  const lastSpaceIndex = inputString.lastIndexOf(' ', maxLength)

  // If there is no space within the specified length, truncate at the specified length
  const truncatedIndex = lastSpaceIndex !== -1 ? lastSpaceIndex : maxLength

  // Truncate the string
  const truncatedString = inputString.substring(0, truncatedIndex)

  return truncatedString
}
const getHeightInCm = (feet: number, inches: number): string => {
  console.log(feet, 'ft', inches, 'in')
  if (isNaN(feet) && isNaN(inches)) {
    return ''
  }
  const totalInches = feet * 12 + inches
  const cm = totalInches * 2.54
  console.log(cm, 'cm')

  return Math.round(cm).toString()
}

const convertHeight = (cm: number): { feet: string; inches: string } => {
  if (isNaN(cm)) {
    return { feet: '', inches: '' }
  }
  const totalInches = cm / 2.54 // Convert cm to inches
  let feet = Math.floor(totalInches / 12) // Get the number of feet
  let inches = Math.round(totalInches % 12) // Get the remaining inches

  // Adjust for rounding if inches equals 12
  if (inches === 12) {
    feet += 1
    inches = 0
  }

  return {
    feet: feet.toString() || '0',
    inches: inches.toString() || '0',
  }
}
const downloadCSVFile = (csv: any, fileName: string) => {
  const aTag: HTMLAnchorElement = document.createElement('a')
  const csvData = new Blob([csv], { type: 'text/csv' })
  aTag.href = URL.createObjectURL(csvData)
  aTag.target = '_blank'
  aTag.download = fileName + '.csv'
  aTag.click()
}

const IndianRupeeFormatFromStringWithSymbol = (num: string) => {
  const parsedInt = parseInt(num)
  if (isNaN(parsedInt)) {
    return num
  }
  return `₹${Intl.NumberFormat('en-IN').format(parseInt(num))}`
}
const formatCurrency = (num: string, currencySymbol: string, locale: string = 'en-IN') => {
  const parsedInt = parseInt(num)
  if (isNaN(parsedInt)) {
    return num
  }
  return `${currencySymbol}${Intl.NumberFormat(locale).format(parsedInt)}`
}

/* ---------- DISABLED (VAPT #2): unused AES-ECB helper, no callers ----------
const encryptData = ({ data, key }: { data: Record<string, any> | string; key: string }) => {
  console.log({ data, key })

  // Convert the data to a string
  const jsonString = JSON.stringify(data)

  // Encryption key
  // const key: string = process.env.REACT_APP_SIGP_DECRYPTION_SECRETE_KEY || ''
  const encKey = enc.Utf8.parse(key)

  // Encrypt the data
  const encrypted = AES.encrypt(jsonString, encKey, {
    mode: mode.ECB,
  })

  // The encrypted data in base64 format
  const encryptedBase64 = encrypted.toString()

  console.log('Encrypted Data:', encryptedBase64)
  return encryptedBase64
}
---------------------------------------------------------------------------- */

export const formatIndianRupee = (amount: number): string => {
  if (!amount) return '-'
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
  }).format(amount)
}

const numDifferentiation = (value: number) => {
  const val = Math.abs(value)
  if (val >= 10000000) return `${(value / 10000000).toFixed(2)}cr`
  if (val >= 100000) return `${(value / 100000).toFixed(2)}lakh`
  if (val >= 10000) return `${(value / 1000).toFixed(2)}K`
  return value
}

const generatePieChartData = (
  data: {
    name: string
    value: number
    [otherKey: string]: any
  }[],
  noOfSegments: number,
) => {
  if (data.length === noOfSegments || data.length < noOfSegments) {
    return [...data]
  } else {
    // sort this array according to value in descending order
    const sortedData = data.sort((a, b) => b.value - a.value)
    const updatedData = sortedData.slice(0, noOfSegments)

    return [
      ...updatedData,
      {
        name: 'Others',
        value: sortedData.slice(noOfSegments).reduce((acc, curr) => acc + curr.value, 0),
      },
    ]
  }
}

export {
  IndianRupeeFormatFromString,
  onlyAllowTypingNumbers,
  onlyAllowTypingAlphabet,
  getManufacturingYearArr,
  getExistingNoClaimBonusArr,
  validateVehicleNumber,
  checkVehicleNumber,
  copyToClipboard,
  getAgeFromDob,
  validateVehicleRtoNumber,
  getMemberTypeFromAge,
  getDOBfromAge,
  pincodeLabelFormatter,
  getDateFromDDMMYYYY,
  pincodeLabelFormatterLife,
  pincodeLabelFormatterHealth,
  getRegistrationDateFromManufacturingYear,
  getArrayFromObj,
  getExistingPolicyExpMinDate,
  getTpPolicyEndMinDate,
  calculateBMI,
  getDropdownArrayFromRecord,
  showNestedError,
  onlyAllowTypingAlphabetNumeric,
  maxAgeCalculator,
  getAgeObjFromDob,
  onlyAllowTypingNumbers2,
  getAccountTypeBasedOnIndex,
  getInvestmentType,
  spConsentFormQuestionsMap,
  customerConsentFormQuestionsMap,
  onlyAllowAlphaNumeric,
  bankHypothecationLabelFormatter,
  sortObjectBasedOnKeys,
  formatSeconds,
  getFallbackImageHtml,
  makeQuery,
  detectDeviceType,
  maskEmail,
  maskPhoneNumber,
  safeSplitFunction,
  getHeightInCm,
  truncateStringToLimitedWords,
  IndianRupeeFormatFromStringWithSymbol,
  IndianRupeeFormatFromStringOrNumber,
  capitalizeFirstLetter,
  downloadCSVFile,
  // checkCameraSupport,
  policyNumberCheck,
  convertHeight,
  getAge,
  numDifferentiation,
  generatePieChartData,
  formatCurrency,
}
